import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'

export type SyncResult = {
    totalExternalSubscriptions?: number
    createdSubscriptions?: number
    updatedSubscriptions?: number
    skippedSubscriptions?: number
    errors?: string[]
    warnings?: string[]
}

export const uploadFastboundFile = (file: File): Promise<SyncResult> => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/v2/subscriptions/fastbound', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}

type UseUploadFastboundFileOptions = {
    mutationConfig?: MutationConfig<typeof uploadFastboundFile>
}

export const useUploadFastboundFile = ({ mutationConfig }: UseUploadFastboundFileOptions = {}) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: uploadFastboundFile,
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['fastbound-files'] })
            mutationConfig?.onSuccess?.(...args)
        },
        ...mutationConfig,
    })
}


